var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tit-mod-secs clearfix title-header"},[_c('h3',{staticClass:"fl font-s16",staticStyle:{"color":"#3884D3"}},[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }